import { Organization } from 'models/organization';
import moment from 'moment';

export const TIME_FORMAT = 'h:mm a'; // 1:00 am
export const DATE_FORMAT = 'ddd, D MMM YYYY'; // Tue, 2 Mar 2021
export const DATE_FORMAT_SHORT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const DATETIME_FORMAT_AT = `${DATE_FORMAT} [at] ${TIME_FORMAT}`;
export const DATETIME_FORMAT_TZ = `${DATE_FORMAT} ${TIME_FORMAT} z`;

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const formatDateForApi = (date: moment.Moment | string | null | undefined): string | null =>
  date ? moment(date).format(API_DATE_FORMAT) : null;

export function getDateFromQueryString(qs: string | string[] | null, fallback?: moment.Moment): moment.Moment | undefined {
  if (qs instanceof Array) {
    return getDateFromQueryString(qs[0], fallback);
  }
  if (qs) {
    const dt = moment(qs);
    if (dt.isValid()) {
      return dt;
    }
  }
  return fallback;
}

export const GetCurrentFYDates = (org: Organization) => {
  const now = moment();
  const startOfDay = now.clone().startOf('day');
  const month = startOfDay.month() + 1; // Because JS Jan=0 and in our configuration Jan=1
  const year = month >= org.country.fyStartMonth ? startOfDay.year() : startOfDay.year() - 1;
  const fyStart = startOfDay.clone().set({ date: org.country.fyStartDay, month: org.country.fyStartMonth - 1, year });
  const fyEnd = fyStart.clone().add({ year: 1 }).add({ millisecond: -1 });
  return { fyStart, fyEnd, now, startOfDay };
};
